import React, { useState, useEffect } from 'react';
import { toast } from 'sonner';
import { X, Sparkles, CheckCircle2, ShieldCheck, Zap, Coins } from 'lucide-react';
import { auth, db } from '../../firebase';
import { doc, getDoc, updateDoc } from 'firebase/firestore';

export const PremiumModal = ({ isOpen, onClose }) => {
    const currentUser = auth.currentUser;
    const [loading, setLoading] = useState(false);
    const [isAlreadyPremium, setIsAlreadyPremium] = useState(false);

    useEffect(() => {
        const checkPremium = async () => {
            if (!currentUser) return;
            try {
                const snap = await getDoc(doc(db, 'users', currentUser.uid));
                if (snap.exists() && snap.data().isPremium) {
                    setIsAlreadyPremium(true);
                }
            } catch(e) {}
        };
        if (isOpen) checkPremium();
    }, [currentUser, isOpen]);
    const isIndia = Intl.DateTimeFormat().resolvedOptions().timeZone === 'Asia/Calcutta' || Intl.DateTimeFormat().resolvedOptions().timeZone === 'Asia/Kolkata';
    const displayPrice = isIndia ? '₹149/mo' : '$4.99/mo';
    if (!isOpen) return null;

    const handleCancelSubscription = () => {
        const businessId = 'bus_0Nl0n0CX5mKITApXMQvCR';
        const portalUrl = `https://test.customer.dodopayments.com/login/${businessId}`;
        window.open(portalUrl, '_blank');
    };

    const handleUpgrade = async () => {
        toast.info("Coming soon!");
    };

    return (
        <div className="fixed inset-0 bg-black/80 flex items-center justify-center z-50 p-4">
            <div className="bg-[#111] border border-[#333] rounded-3xl p-6 md:p-8 max-w-md w-full relative overflow-hidden">
                {/* Background Glow */}
                <div className="absolute -top-20 -right-20 w-64 h-64 bg-[#0BD9E5]/20 blur-[100px] rounded-full pointer-events-none" />
                
                <button 
                    onClick={onClose}
                    className="absolute top-4 right-4 w-8 h-8 flex items-center justify-center rounded-full bg-white/10 hover:bg-white/20 transition-colors z-10"
                >
                    <X size={18} className="text-white" />
                </button>

                <div className="flex flex-col items-center mb-6 relative z-10">
                    <div className="w-16 h-16 rounded-2xl bg-gradient-to-br from-[#0BD9E5] to-[#BD00FF] p-[2px] mb-4 shadow-[0_0_30px_rgba(11,217,229,0.3)]">
                        <div className="w-full h-full bg-[#111] rounded-[14px] flex items-center justify-center">
                            <Sparkles size={32} className="text-[#0BD9E5]" />
                        </div>
                    </div>
                    <h2 className="text-3xl font-extrabold text-white tracking-tight mb-2">Spark Premium</h2>
                    <p className="text-gray-400 text-center">Unlock your full potential. Earn real cash, dominate the feed, and get exclusive access.</p>
                </div>

                <div className="flex flex-col gap-4 mb-8 relative z-10">
                    <div className="flex items-center gap-4 bg-white/5 p-4 rounded-2xl border border-white/5">
                        <div className="w-10 h-10 rounded-full bg-[#BD00FF]/10 flex items-center justify-center shrink-0">
                            <Coins size={20} className="text-[#BD00FF]" />
                        </div>
                        <div>
                            <h4 className="text-white font-bold mb-0.5">Creator Program</h4>
                            <p className="text-sm text-gray-400">Turn your viral shadows into real cash. Earn $0.10 for every 1,000 views.</p>
                        </div>
                    </div>
                    
                    <div className="flex items-center gap-4 bg-white/5 p-4 rounded-2xl border border-white/5">
                        <div className="w-10 h-10 rounded-full bg-green-500/10 flex items-center justify-center shrink-0">
                            <Sparkles size={20} className="text-green-500" />
                        </div>
                        <div>
                            <h4 className="text-white font-bold mb-0.5">Voices Unlocked</h4>
                            <p className="text-sm text-gray-400">Skip the queues and access exclusive 1-1 and 4-4 Rooms.</p>
                        </div>
                    </div>

                    <div className="flex items-center gap-4 bg-white/5 p-4 rounded-2xl border border-white/5">
                        <div className="w-10 h-10 rounded-full bg-[#0BD9E5]/10 flex items-center justify-center shrink-0">
                            <Sparkles size={20} className="text-[#0BD9E5]" />
                        </div>
                        <div>
                            <h4 className="text-white font-bold mb-0.5">Premium Member Badge</h4>
                            <p className="text-sm text-gray-400">Get the exclusive Sparkle badge on your profile and stand out from the crowd.</p>
                        </div>
                    </div>

                    <div className="flex items-center gap-4 bg-white/5 p-4 rounded-2xl border border-white/5">
                        <div className="w-10 h-10 rounded-full bg-[#FF4444]/10 flex items-center justify-center shrink-0">
                            <Zap size={20} className="text-[#FF4444]" />
                        </div>
                        <div>
                            <h4 className="text-white font-bold mb-0.5">Ad-Free Experience</h4>
                            <p className="text-sm text-gray-400">Enjoy a 100% ad-free experience. No distractions, just pure content.</p>
                        </div>
                    </div>

                    <div className="flex items-center gap-4 bg-white/5 p-4 rounded-2xl border border-white/5">
                        <div className="w-10 h-10 rounded-full bg-yellow-500/10 flex items-center justify-center shrink-0">
                            <ShieldCheck size={20} className="text-yellow-500" />
                        </div>
                        <div>
                            <h4 className="text-white font-bold mb-0.5">Early Access</h4>
                            <p className="text-sm text-gray-400">Be the first to test drive experimental features before anyone else.</p>
                        </div>
                    </div>
                </div>

                <div className="relative z-10">
                    {isAlreadyPremium ? (
                        <div className="flex flex-col items-center w-full">
                            <p className="text-sm text-emerald-400 font-semibold text-center mb-4">Your subscription is active. Enjoy all premium perks!</p>
                            
                            <button 
                                onClick={handleCancelSubscription}
                                className="w-full bg-red-500/10 border border-red-500/30 hover:bg-red-500/20 text-red-400 font-bold text-sm py-3.5 rounded-full flex items-center justify-center gap-2 transition-colors cursor-pointer"
                            >
                                Cancel or Manage Subscription
                            </button>
                        </div>
                    ) : (
                        <>
                            <button 
                                onClick={handleUpgrade}
                                disabled={loading}
                                className="w-full bg-gradient-to-r from-[#0BD9E5] to-[#BD00FF] text-white font-bold text-lg py-4 rounded-full hover:opacity-90 transition-opacity flex items-center justify-center"
                            >
                                {loading ? 'Processing...' : `Subscribe for ${displayPrice}`}
                            </button>
                            <p className="text-xs text-gray-500 text-center mt-4">Cancel anytime. Secured by Dodo Payments.</p>
                        </>
                    )}
                </div>
            </div>
        </div>
    );
};

export default PremiumModal;
